module.exports = __webpack_public_path__ + "img/about3.746e6324.png";